import React from "react"
import { Box } from "@mui/material"

import LockingSystemComponent from "./LockingSystemComponent"

import {
	LockingSystemComponentType,
	LockingSystemPreviewProduct,
	LockingSystemCharges,
} from "@secureo/common/typings/LockingSystem"
import { LockingSystemReducerState } from "reducers/lockingSystemReducer"

const LockingSystemComponentGroup = ({
	type,
	isLoading,
	isFrozen,
	componentUuids,
	componentsByUuid,
	taxRate,
	setComponentQuantity,
	setEditComponentModalUuid,
	availableLockingComponents,
	availableKeyComponents,
	charges,
	setSystemComponentName,
	setComponentProduct,
	setComponentSystem,
	setComponentOuterLength,
	setComponentInnerLength,
}: Props) => {
	return (
		<>
			{componentUuids.map((uuid, rowIndex) => {
				const lockingSystemComponent = componentsByUuid[uuid]

				return (
					<Box mb={3} key={uuid}>
						<div
							style={{
								background: "white",
								borderLeft: "3px solid #4691CE",
								borderBottomLeftRadius: 3,
								borderTopLeftRadius: 3,
							}}
						>
							<table style={{ width: "100%" }}>
								<tbody>
									<LockingSystemComponent
										isFrozen={isFrozen}
										isLoading={isLoading}
										lockingSystemComponent={lockingSystemComponent}
										index={rowIndex}
										taxRate={taxRate}
										type={type}
										setComponentQuantity={setComponentQuantity}
										setEditComponentModalUuid={setEditComponentModalUuid}
										availableLockingComponents={availableLockingComponents}
										availableKeyComponents={availableKeyComponents}
										charges={charges}
										setSystemComponentName={setSystemComponentName}
										setComponentProduct={setComponentProduct}
										setComponentSystem={setComponentSystem}
										setComponentOuterLength={setComponentOuterLength}
										setComponentInnerLength={setComponentInnerLength}
									/>
								</tbody>
							</table>
						</div>
					</Box>
				)
			})}
		</>
	)
}

interface Props {
	type: LockingSystemComponentType
	isLoading: boolean
	isFrozen: boolean
	componentUuids: string[]
	componentsByUuid: LockingSystemReducerState["componentsByUuid"]
	taxRate: number
	isConfigurationsStep?: boolean
	setComponentQuantity?: (uuid: string, quantity: number) => void
	setEditComponentModalUuid?: (uuid: string) => void
	availableLockingComponents: LockingSystemPreviewProduct[]
	availableKeyComponents: LockingSystemPreviewProduct[]
	charges: LockingSystemCharges
	setSystemComponentName: (uuid: string, name: string) => void
	setComponentProduct: (
		uuid: string,
		lockingSystemPreviewProduct: LockingSystemPreviewProduct,
	) => void
	setComponentSystem: (uuid: string, selectedSystem: string) => void
	setComponentOuterLength: (uuid: string, selectedOuterLength: number) => void
	setComponentInnerLength: (uuid: string, selectedInnerLength: number) => void
}

export default LockingSystemComponentGroup
